import React from 'react'
import { Link, Image, Box, Flex } from '@chakra-ui/react'
import { Burger } from './BurgerMenu.tsx'

export const Header = () => {
  return (
    <Box>
      <Flex as="header" className='header'>
        <Box className='pcDisplayNone'>
          <Burger />
        </Box>
        <Image src='/img/logo.png' alt="Logo" pl={5} />
        <Box className='linkContainer' as="nav">
          <Link href='#video'>VIDEO</Link>
          <Link href='#concept'>CONCEPT</Link>
          <Link href='#feature'>FEATURE</Link>
          <Link href='#lineup'>LINE UP</Link>
          <Link href='#colorchart'>COLOR CHART</Link>
          <Link href='#interview'>INTERVIEW</Link>
          <Link href='#dealers'>DEALERS</Link>
        </Box>
      </Flex>
    </Box>
  )
}
